import { c as _c } from "react/compiler-runtime";
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { BBookableTypeEnum, BRangeBoundEnum } from '@/types/backend';
import { capitalize, formatCallPriceText, formatDuration } from '@winelidays/wld-tsx-2/utils';
import PriceTag from './PriceTag';
const SHOW_DURATION_ENTITY_TYPES = [BBookableTypeEnum.Activity, BBookableTypeEnum.Meal];
const SHOW_PARTICIPANTS_ENTITY_TYPES = [BBookableTypeEnum.Activity, BBookableTypeEnum.Meal];
const getStaticInfo = ({ callPrice, translate, currencySymbol, entityType, information, showDuration, showParticipants }) => {
    const p = [];
    // PRICE
    if (callPrice) {
        p.push(`${formatCallPriceText({
            callPrice,
            translate,
            currencySymbol,
            entityType: entityType
        })}${callPrice.value > 0 ? ` / ${translate('messages.adult', {
            count: 1
        })}` : callPrice.isConditional ? ` ${translate('messages.with_conditions')}` : ''}`);
    }
    if (information) {
        // DURATION
        if (showDuration && 'duration' in information) {
            p.push(formatDuration({
                duration: information.duration,
                translate
            }));
        }
        // PARTICIPANTS
        if (showParticipants && 'participants' in information) {
            const min = typeof information.participants.lower === 'number' ? information.participants.lowerBound === BRangeBoundEnum.IncludeLower ? information.participants.lower : information.participants.lower + 1 : null;
            const max = typeof information.participants.upper === 'number' ? information.participants.upperBound === BRangeBoundEnum.IncludeUpper ? information.participants.upper : information.participants.upper - 1 : null;
            if (min !== null) {
                if (max !== null) {
                    if (min === max) {
                        p.push(translate('practical.participants.exact', {
                            number: min,
                            long: false
                        }));
                    }
                    else {
                        p.push(translate('practical.participants.from_min_max', {
                            min,
                            max,
                            long: false
                        }));
                    }
                }
                else {
                    p.push(translate('practical.participants.min', {
                        min,
                        long: false
                    }));
                }
            }
            else {
                p.push(translate('practical.participants.max', {
                    max,
                    long: false
                }));
            }
        }
    }
    if (p.length) {
        p[0] = capitalize(p[0]);
    }
    return p.join(' - ');
};
const EntityInfo = t0 => {
    const $ = _c(14);
    const { calculatedPrice, callPrice, entityType, information, mapPopup, vertical } = t0;
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    let t1;
    if ($[0] !== callPrice || $[1] !== currencySymbol || $[2] !== entityType || $[3] !== information || $[4] !== translate) {
        const showDuration = SHOW_DURATION_ENTITY_TYPES.includes(entityType);
        const showParticipants = SHOW_PARTICIPANTS_ENTITY_TYPES.includes(entityType);
        t1 = getStaticInfo({
            callPrice,
            translate,
            currencySymbol,
            entityType,
            information,
            showDuration,
            showParticipants
        });
        $[0] = callPrice;
        $[1] = currencySymbol;
        $[2] = entityType;
        $[3] = information;
        $[4] = translate;
        $[5] = t1;
    }
    else {
        t1 = $[5];
    }
    const staticInfo = t1;
    const spanClassName = `max-w-full overflow-hidden font-semibold text-gray-500 my-1 ${mapPopup && !vertical ? "text-xs" : "text-sm"}`;
    let t2;
    if ($[6] !== calculatedPrice) {
        t2 = calculatedPrice && <PriceTag {...calculatedPrice}/>;
        $[6] = calculatedPrice;
        $[7] = t2;
    }
    else {
        t2 = $[7];
    }
    let t3;
    if ($[8] !== spanClassName || $[9] !== staticInfo) {
        t3 = <span className={spanClassName}>{staticInfo}</span>;
        $[8] = spanClassName;
        $[9] = staticInfo;
        $[10] = t3;
    }
    else {
        t3 = $[10];
    }
    let t4;
    if ($[11] !== t2 || $[12] !== t3) {
        t4 = <p className="experience-info inline-flex items-center flex-wrap">{t2}{t3}</p>;
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
    }
    else {
        t4 = $[13];
    }
    return t4;
};
export default EntityInfo;
